import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export function InfoIcon({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        fill="none"
        viewBox="0 0 17 16"
      >
        <path
          fill="#768190"
          d="M8.5 1a7 7 0 100 14 7 7 0 000-14zm-.25 3a.75.75 0 110 1.5.75.75 0 010-1.5zm2.25 7.396h-4V10.27h1.438V7.396H7V6.27h2.063v4H10.5v1.125z"
        ></path>
      </svg>
    </div>
  )
}

InfoIcon.propTypes = {
  className: PropTypes.string,
}
